import { useEffect, useState } from 'react';

const DOC_CHECKLISTS = {
  GST: ['Sales invoices', 'Purchase invoices', 'GSTR-2B reconciliation'],
  TDS: ['Payment details', 'Section-wise deductions', 'Challan details'],
  ROC: ['Financial statements', 'Board resolution', 'Director details'],
  Income_Tax: ['P&L account', 'Balance sheet', 'Tax computation'],
  PF: ['Challan receipt', 'Employee contribution details'],
  ESIC: ['Challan receipt', 'Employee contribution details'],
};

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function PrepareModal({ item, onClose, onMarkInProgress, busy }) {
  if (!item) return null;
  const checklist = DOC_CHECKLISTS[item.category] || ['Supporting documents'];

  return (
    <div className="ncf-modal-overlay" onClick={onClose}>
      <div className="ncf-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="ncf-modal-title">Prepare {item.form_name}</h3>
        <div className="ncf-modal-body">
          <p>
            <strong>Due Date:</strong> {formatDate(item.due_date)}
          </p>
          <p>
            <strong>Penalty if missed:</strong> ₹{item.penalty_per_day}/day
          </p>
          <p className="ncf-checklist-title">Documents needed:</p>
          <ul className="ncf-checklist">
            {checklist.map((doc) => (
              <li key={doc}>{doc}</li>
            ))}
          </ul>
        </div>
        <div className="ncf-modal-actions">
          <button className="dash-btn cal-btn-grey" type="button" onClick={onClose}>
            Close
          </button>
          <button
            className="dash-btn dash-btn-orange"
            type="button"
            disabled={busy}
            onClick={onMarkInProgress}
          >
            {busy ? 'Updating...' : 'Mark as In Progress'}
          </button>
        </div>
      </div>
    </div>
  );
}

export function ViewFiledModal({ item, onClose }) {
  if (!item) return null;

  return (
    <div className="ncf-modal-overlay" onClick={onClose}>
      <div className="ncf-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="ncf-modal-title">{item.form_name} — Filed Details</h3>
        <div className="ncf-modal-body">
          <p className="ncf-filed-status">Status: Filed ✓</p>
          <p>
            <strong>Date of Filing:</strong> {formatDate(item.date_of_filing)}
          </p>
          {item.requires_deposit && (
            <p>
              <strong>Date of Deposit:</strong> {formatDate(item.date_of_deposit)}
            </p>
          )}
          <p>
            <strong>Period:</strong> {item.period_month}/{item.period_year}
          </p>
          <p>
            <strong>Notes:</strong> {item.notes || '—'}
          </p>
        </div>
        <div className="ncf-modal-actions">
          <button className="dash-btn cal-btn-grey" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export function FileModal({ item, onClose, onConfirm, onClear, busy }) {
  const [dateOfFiling, setDateOfFiling] = useState('');
  const [dateOfDeposit, setDateOfDeposit] = useState('');
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    setDateOfFiling(item?.date_of_filing || '');
    setDateOfDeposit(item?.date_of_deposit || '');
    setLocalError(null);
  }, [item]);

  if (!item) return null;

  const isEditing = item.status === 'filed';
  const needsDeposit = !!item.requires_deposit;
  const canSubmit = Boolean(dateOfFiling) && (!needsDeposit || Boolean(dateOfDeposit));

  const handleSubmit = () => {
    setLocalError(null);
    const result = onConfirm({ date_of_filing: dateOfFiling, date_of_deposit: dateOfDeposit || null });
    if (result && typeof result.catch === 'function') {
      result.catch((err) =>
        setLocalError(err.response?.data?.detail || err.message || 'Could not mark as filed')
      );
    }
  };

  const handleClear = () => {
    setLocalError(null);
    const result = onClear();
    if (result && typeof result.catch === 'function') {
      result.catch((err) =>
        setLocalError(err.response?.data?.detail || err.message || 'Could not clear filing')
      );
    }
  };

  return (
    <div className="cal-modal-overlay" onClick={onClose}>
      <div className="cal-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{isEditing ? `Edit Filing Details — ${item.form_name}` : `Mark ${item.form_name} as Filed?`}</h3>
        {localError && <p className="dash-error">{localError}</p>}
        <label className="cal-modal-label">
          Date of filing
          <input
            type="date"
            className="cal-modal-date"
            value={dateOfFiling}
            onChange={(e) => setDateOfFiling(e.target.value)}
          />
        </label>
        {needsDeposit && (
          <label className="cal-modal-label">
            Date of deposit
            <input
              type="date"
              className="cal-modal-date"
              value={dateOfDeposit}
              onChange={(e) => setDateOfDeposit(e.target.value)}
            />
          </label>
        )}
        <div className="cal-modal-actions">
          {isEditing && onClear && (
            <button
              className="dash-btn cal-btn-grey"
              type="button"
              disabled={busy}
              onClick={handleClear}
              style={{ marginRight: 'auto' }}
            >
              Clear (Mark Unfiled)
            </button>
          )}
          <button className="dash-btn cal-btn-grey" type="button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="dash-btn dash-btn-orange"
            type="button"
            disabled={busy || !canSubmit}
            onClick={handleSubmit}
          >
            {busy ? 'Saving...' : isEditing ? 'Save Changes' : 'Mark as Filed'}
          </button>
        </div>
      </div>
    </div>
  );
}
